import {WinNumbers} from '@fantasmagames/slot/src/modules/winpresentation/WinNumbers';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';

export class WinFieldWinNumbers extends WinNumbers {

	constructor(resources: ResourcesLoader, symbolIDPrefix: string, texture?: PIXI.Texture) {
		super(resources, symbolIDPrefix, texture);

		this._numbersContainer.anchor.set(0.0, 0.5);
		this._autoCenterMyself = false;

	}
}



// WEBPACK FOOTER //
// ./src/winfield/WinFieldWinNumbers.ts